/**
 * Módulo de Configuração de Webhooks Uazapi
 * Arquitetura: Isola a lógica de configuração e resgate de webhooks na API.
 */

import { fetchAPI } from './client';

export const setupWebhook = async (instanceName: string) => {
    const webhookDomain = import.meta.env.VITE_WEBHOOK_BASE_URL;
    if (!webhookDomain) {
        console.error('[Uazapi Webhook] VITE_WEBHOOK_BASE_URL is not defined in .env');
        return { success: false };
    }

    try {
        const webhookUrl = `${webhookDomain}/uazapi-webhook/${instanceName}`;
        
        await fetchAPI(`webhook`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'instance': instanceName
            },
            body: JSON.stringify({
                enabled: true,
                url: webhookUrl,
                events: ["messages", "messages_update", "connection", "history"],
                excludeMessages: ["isGroupYes"],
                addUrlEvents: false
            })
        });
        
        console.log(`[Uazapi Webhook] Configurado: ${webhookUrl}`);
        return { success: true };
    } catch (e) {
        console.error('[Uazapi Webhook] Falha ao configurar webhook:', e);
        return { success: false };
    }
};

export const getWebhookConfig = async (instanceName: string) => {
    try {
        const response = await fetchAPI(`webhook`, {
            method: 'GET',
            headers: { 'instance': instanceName }
        });
        if (Array.isArray(response) && response.length > 0) {
            return response[0];
        }
        return null;
    } catch (e) {
        console.error('[Uazapi Webhook] Falha ao obter configuração:', e);
        return null;
    }
};
